export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "db-repetition-counter-worker_d24431ed1dc7a01eac7e.worker.js");
}
